import React, { Component } from "react";
import SocialSecurity from "../../../components/SocialSecurity/SocialSecurity";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : SocialSecurityForm
Description : Compoente que alberga el resto del formulario de registro definido en el directorio de componentes
Date Autor Modification
================================================================================
04/11/2021 Cristian Andres Pizo Mina – Se llama al componente de SocialSecurity con sus respectivos parámetros.
================================================================================ */

class SocialSecurityForm extends Component{
    constructor(props){
        super(props);
    }
    render(){
        return(
            <SocialSecurity/>
        )
    }
}

export default SocialSecurityForm;